module.exports = __webpack_public_path__ + "static/media/turntable.f3b0d3da.svg";